import { render, staticRenderFns } from "./personStatis.vue?vue&type=template&id=d80e6ee8&scoped=true&"
import script from "./personStatis.vue?vue&type=script&lang=js&"
export * from "./personStatis.vue?vue&type=script&lang=js&"
import style0 from "./personStatis.vue?vue&type=style&index=0&id=d80e6ee8&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80e6ee8",
  null
  
)

export default component.exports